module.exports = __webpack_public_path__ + "img/company31.bb29e731.png";